/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IInstantMessagePageOwnProps, IInstantMessagePageStateProps, IInstantMessagePageDispatchProps, InstantMessagePage } from "../../components/instantMessage/InstantMessagePage";
import { ITypedOption } from "../../models/common/typedOption";
import { getInstantMessagePage, InstantMessageThunkDispatch } from "source/models/store/instantMessage/storeInstantMessageEffects";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IInstantMessagePageOwnProps): IInstantMessagePageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            instantMessagePage: null
        };
    }
    const instantMessage = applicationState.instantMessage;
    return {
        appState: applicationState.session,
        dataId: instantMessage.page.dataId,
        instantMessagePage: instantMessage.page.instantMessagePage
    };
}

export function mapDispatchToProps(dispatch: InstantMessageThunkDispatch): IInstantMessagePageDispatchProps {
    return {
        onGetInstantMessagePage: () => dispatch(getInstantMessagePage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IInstantMessagePageStateProps, IInstantMessagePageDispatchProps, IInstantMessagePageOwnProps>(mapStateToProps, mapDispatchToProps)(InstantMessagePage);